/*
 * Public API Surface of ng-alert-box
 */

export * from './lib/ng-alert-box.service';
export * from './lib/ng-alert-box.component';
export * from './lib/ng-alert-box.module';
